module.exports = __webpack_public_path__ + "static/media/message-square.b98745a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/message-square.svg
// module id = 834
// module chunks = 21